import { render, staticRenderFns } from "./originalManage.vue?vue&type=template&id=b267ba48&scoped=true&"
import script from "./originalManage.vue?vue&type=script&lang=js&"
export * from "./originalManage.vue?vue&type=script&lang=js&"
import style0 from "./originalManage.vue?vue&type=style&index=0&id=b267ba48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b267ba48",
  null
  
)

export default component.exports